const SOURCE_LABEL = {
  POSITION_EXPERIENCE: '体验仓位',
  NORMAL: '正常仓位',
}

/**
 * 仓位类型展示：优先中文 positionCategory，其次 source / experiencePosition
 */
export function formatPositionCategory(row = {}) {
  const category = row.positionCategory
  if (category && SOURCE_LABEL[category]) {
    return SOURCE_LABEL[category]
  }
  if (category && category !== 'POSITION_EXPERIENCE' && category !== 'NORMAL') {
    return category
  }
  if (SOURCE_LABEL[row.source]) {
    return SOURCE_LABEL[row.source]
  }
  if (row.experiencePosition) {
    return '体验仓位'
  }
  return '正常仓位'
}
